var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{class:[
    'kvass-icon',
    `kvass-icon--size-${_vm.size}`,
    { 'kvass-icon--spin': _vm.spin, 'kvass-icon--rotate': _vm.rotation },
  ],style:(_vm.style),attrs:{"icon":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }